import React from 'react';

const MR = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_92"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_92)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#006331"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.498 7.25L9.028 8.023L9.30799 6.386L8.12 5.226L9.76299 4.989L10.498 3.499L11.232 4.989L12.875 5.226L11.685 6.386L11.967 8.022"
        fill="#FFC500"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.965 5.938C14.988 6.122 15 6.31 15 6.5C15 8.985 12.985 11 10.5 11C8.015 11 6 8.985 6 6.5C6 6.31 6.012 6.122 6.035 5.937C6.312 7.665 8.205 9 10.5 9C12.795 9 14.688 7.664 14.965 5.937V5.938Z"
        fill="#FFC500"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default MR;
